/** @jsx jsx */
import { jsx, css } from '@emotion/core'

const Color = css`
  width: inherit;
  height: auto;
`

export default function BettingHistoryIco() {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="22" height="22" viewBox="0 0 22 22" css={Color}>
      <g id="그룹_6744" data-name="그룹 6744" transform="translate(-2731 -5902)">
        <rect id="사각형_6317-12" data-name="사각형 6317-12" width="22" height="22" transform="translate(2731 5902)" opacity="0"/>
        <path id="패스_5723" className="fill" data-name="패스 5723"
              d="M108.284,509.426c-2.2,0-4.406.016-6.609,0a3.012,3.012,0,0,1-3.315-3.273q-.038-6.716,0-13.431a3,3,0,0,1,2.745-3.235,2.944,2.944,0,0,1,.5,0c2.093-.029,4.187-.043,6.278.028.4.013,1.067.411,1.106.7.1.76-.581.773-1.151.773-1.982,0-3.965-.008-5.948.006-1.469.01-2,.53-2.006,1.991q-.018,6.5,0,12.99c0,1.4.537,1.93,1.943,1.935q6.5.02,13,0c1.458,0,1.957-.521,1.977-2.017.019-1.431,0-2.862.013-4.293,0-.56,0-1.222.771-1.206s.741.68.743,1.237c0,1.541.029,3.083-.01,4.623a3.012,3.012,0,0,1-2.846,3.169,3.313,3.313,0,0,1-.359,0C112.838,509.446,110.561,509.425,108.284,509.426Z"
              transform="translate(2633.658 5413.554)" fill="#1c202b"/>
        <path id="패스_5724" className="fill" data-name="패스 5724" d="M108.238,500.93c2.347-2.371,4.507-4.556,6.67-6.736a5.151,5.151,0,0,1,1.05-.955,1.01,1.01,0,0,1,.949.045c.174.178.1.64.06.968-.019.149-.221.28-.351.409-2.486,2.486-4.985,4.959-7.453,7.463a1.1,1.1,0,0,1-1.847,0c-1.061-1.113-2.174-2.177-3.253-3.272-.4-.41-.994-.871-.414-1.472s1.056-.05,1.469.369C106.113,498.754,107.1,499.773,108.238,500.93Z" transform="translate(2633.658 5413.554)" fill="#1c202b"/>
      </g>
    </svg>
  )
}
